import {
  colors,
  transition,
  ellipsis,
  UI_BODY_SM_DF,
  UI_CAPTION_DF,
  UI_BODY_SEMIBOLD_SM_DF,
  colors2,
} from "oolib";
import styled, { css } from "styled-components";
import { motion } from "framer-motion";

export const StyledBadgeContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0.4rem;
`;

export const StyledContainer = styled.div`
  display: flex;
  min-height: 4rem;
  border-radius: 6px;
  position: relative;
  ${({ showActionsOnHover }) =>
    showActionsOnHover &&
    css`
      &:hover {
        ${StyledRightActionsWrapper} {
          display: flex;
        }

        ${StyledEmbeddedActionsContainer} {
          display: flex;
        }

        ${StyledBadgeContainer} {
          display: none;
        }
      }
    `}

  background-color: ${colors2.grey2};

  border: 1px solid transparent;

  ${({ editable }) =>
    editable
      ? css`
          border: 1px solid ${colors2.grey80};
          box-shadow: 0 4px 10px #00000012;
        `
      : css`
          &:hover {
            border: 1px solid ${colors2.grey30};
          }
        `}
`;

export const StyledDragHandleWrapper = styled.div`
  padding: 1rem 1rem;

  &:active {
    cursor: grabbing;
  }
  display: flex;
  align-items: center;
  /* max-height: 4rem; */
`;
export const StyledContentWrapper = styled.div`
  padding: 0 1rem 0 0;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 3.6rem;
  position: relative;
`;

export const StyledIconAndTitleWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  position: relative;
`;

export const StyledTitleWrapper = styled.div`
  min-width: 0;
  width: 100%;
`;

export const StyledTitle = styled(UI_BODY_SEMIBOLD_SM_DF)`
  ${ellipsis};
  line-height: 16px;
  position: relative;
  color: ${colors2.grey80};
  white-space: pre; // preserve user-entered spacing
`;

export const StyledTitleInput = styled.input`
  border: none;
  width: 100%;
  background-color: ${colors.none};
  color: ${colors2.grey80};
  height: 1.6rem;
  &::placeholder {
    color: ${colors.greyColor40};
  }
`;

export const StyledRightActionsWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;

  ${({ alignActions }) =>
    alignActions !== "center" &&
    css`
      position: absolute;
      top: 0.6rem;
      right: 1rem;
    `}

  ${({ showActionsOnHover, loader }) => {
    if (showActionsOnHover && !loader) {
      return css`
        display: none;
      `;
    }
  }}
`;

export const StyledSubtitleWrapper = styled.div`
  /* &:has(.contentEditableLex) > p {
    margin-bottom: 0;
  } */
  /* margin-bottom: -8px; */
`;

export const StyledSubtitle = styled(UI_CAPTION_DF)`
  color: ${colors2.grey70};
`;

export const StyledHr = styled.hr`
  border: none;
  border-bottom: 0.1rem solid ${colors2.grey10};
  margin: 0 -1rem;
`;

export const StyledMoreContentWrapper = styled.div``;

export const StyledDescHelpText = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 1ch;
  color: ${colors2.grey50};
  margin-top: 0.6rem;
`;

export const StyledEmbeddedActionsContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem;
  padding-bottom: 0;
  background: ${({ levelColor }) => levelColor};
  border-top-right-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;

  &::before {
    content: "";
    position: absolute;
    right: 100%;
    top: 0;
    width: 20px;
    background: linear-gradient(
      to right,
      transparent,
      ${({ levelColor }) => levelColor}
    );
  }

  ${({ showActionsOnHover, loader }) => {
    if (showActionsOnHover && !loader) {
      return css`
        display: none;
      `;
    }
  }}
`;

export const StyledErrorWrapper = styled(motion.div)`
  background: ${colors2.redBG};
  border-top-left-radius: 0.6rem;
  border-top-right-radius: 0.6rem;
  padding-bottom: 0.6rem;
  margin-bottom: -0.6rem;
  overflow: hidden;
`;

export const StyledErrorContent = styled.div`
  padding-block: 0.4rem;
  padding-inline: 1rem;
  color: ${colors2.redText};
`;
